'use strict';
var util = angular.module('gymsystem.util');
util.directive('getStarted', ['$rootScope', '$routeParams', '$location', function ($rootScope, $routeParams, $location) {
        return {
            restrict: 'E',
            templateUrl: 'components/widgets/getstarted/getstarted.html',
            scope: {
                s: '=settings'
            },
            controller: ['$scope', function ($scope) {
                    $scope.init = function (iframe) {
                        iframe.src = '/addon/shop.html#/get-started/' + ($routeParams.tab || '');
                    };
                    if ($rootScope.currentStaff && !$rootScope.currentStaff.show_getstarted) {
                        $location.path('/');
                    }
                }]
        };
    }]);
